import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const { currentUser, logout } = useAuth();

  useEffect(() => {
    const handleResize = () => {
      const isLargeScreen = window.innerWidth >= 1024;
      if (!isMounted) {
        setIsOpen(isLargeScreen);
        setIsMounted(true);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMounted]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      try {
        await logout();
        window.location.href = '/login';
      } catch (error) {
        console.error('Logout error:', error);
        alert('Failed to logout. Please try again.');
      }
    }
  };

  return (
    <>
      <button
        onClick={toggleSidebar}
        className="fixed top-4 left-4 z-50 lg:z-10 bg-[#FFB7CE] text-white p-2 rounded-md hover:bg-[#FF9BB8] transition-colors duration-200"
        aria-label={isOpen ? "Close sidebar" : "Open sidebar"}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {isOpen ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          )}
        </svg>
      </button>

      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={toggleSidebar}
        />
      )}

      <div
        className={`
          fixed lg:static top-0 left-0 z-40 h-screen
          bg-[#FFB7CE] shadow-xl transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
          ${isOpen ? 'w-64' : 'w-0'}
          ${isOpen ? 'block' : 'hidden'}
        `}
      >
        <div className="w-64 flex flex-col justify-between h-full py-8">
          <div className="flex flex-col items-center">
            <div className="text-white text-2xl font-bold mb-12 mt-8 lg:mt-0">KHULWAEL</div>
            
            
            <nav className="text-white text-lg font-medium flex flex-col space-y-2 w-full px-4">
              <a 
                href="/dashboard" 
                className="hover:bg-white hover:bg-opacity-20 rounded-lg px-4 py-3 transition-all duration-200"
                onClick={() => window.innerWidth < 1024 && setIsOpen(false)}
              >
                Dashboard
              </a>
              <a 
                href="/projects" 
                className="hover:bg-white hover:bg-opacity-20 rounded-lg px-4 py-3 transition-all duration-200"
                onClick={() => window.innerWidth < 1024 && setIsOpen(false)}
              >
                Projects
              </a>
              <a 
                href="/services" 
                className="hover:bg-white hover:bg-opacity-20 rounded-lg px-4 py-3 transition-all duration-200"
                onClick={() => window.innerWidth < 1024 && setIsOpen(false)}
              >
                Services
              </a>
              <a 
                href="/messages" 
                className="hover:bg-white hover:bg-opacity-20 rounded-lg px-4 py-3 transition-all duration-200"
                onClick={() => window.innerWidth < 1024 && setIsOpen(false)}
              >
                Messages
              </a>
              <a 
                href="/clients" 
                className="hover:bg-white hover:bg-opacity-20 rounded-lg px-4 py-3 transition-all duration-200"
                onClick={() => window.innerWidth < 1024 && setIsOpen(false)}
              >
                Clients
              </a>
              <a href="/reviews" 
                className="hover:bg-white hover:bg-opacity-20 rounded-lg px-4 py-3 transition-all duration-200"
                onClick={() => window.innerWidth < 1024 && setIsOpen(false)}
              >
                Reviews
              </a>
              <a 
                href="/profile" 
                className="hover:bg-white hover:bg-opacity-20 rounded-lg px-4 py-3 transition-all duration-200"
                onClick={() => window.innerWidth < 1024 && setIsOpen(false)}
              >
                Profile
              </a>
            </nav>
          </div>

          {currentUser && (
            <div className="px-4">
              <button
                onClick={handleLogout}
                className="w-full bg-white bg-opacity-60 hover:bg-opacity-30 text-white font-medium py-3 px-4 rounded-lg transition-all duration-200 flex items-center justify-center gap-2"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Sidebar;